import React, { useState } from 'react'
import GroupList, { GroupProps } from './components/GroupList'
import GroupChatDetails from './components/GroupChatDetails'
import GroupDetails from './components/GroupDetails'

type Props = object

const GroupChatList: React.FC<Props> = () => {
  const [showChatList, setShowChatList] = useState(true)
  const [showChatDetails, setShowChatDetails] = useState(false)
  const [showGroupDetails, setShowGroupDetails] = useState(false)
  const [groupInfo, setGroupInfo] = useState<GroupProps | null>(null)

  return (
    <div className="mt-[40px] w-full">
      <div>
        {showChatList && (
          <GroupList
            onClick={(groupInfo: GroupProps) => {
              setGroupInfo(groupInfo)
              setShowChatList(!showChatList)
              setShowChatDetails(true)
            }}
          />
        )}
      </div>

      {showChatDetails && (
        <GroupChatDetails
          groupInfo={groupInfo}
          onClick={() => {
            setShowChatList(!showChatList)
            setShowChatDetails(true)
          }}
          goBack={() => {
            setShowChatDetails(false)
            setShowChatList(true)
          }}
          onClickDetails={() => {
            setShowChatDetails(false)
            setShowGroupDetails(true)
          }}
        />
      )}

      {showGroupDetails && (
        <GroupDetails
          groupInfo={groupInfo}
          goBack={() => {
            setShowGroupDetails(false)
            setShowChatDetails(true)
          }}
          onGroupInfoUpdate={(updated) => setGroupInfo(updated)}
        />
      )}
    </div>
  )
}

export default GroupChatList
